import { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import { PilotMissionStatsProps, PilotMissionStatsState} from '../../../Interfaces/Interfaces';
import PilotStatsContent from '../PilotStatsContent/PilotStatsContent';

const PilotMissionStats = (props: PilotMissionStatsProps) => {

	const { pilotData } = props
	const [state, setState] = useState<PilotMissionStatsState|null>(null)


	useEffect(() => {
		if (pilotData) {
			const {
				airfieldLandings, airfieldTakeoffs, crashes, deaths,
				ejections, farpLandings, farpTakeoffs, /*id,*/
				killsAirDefense, killsArmor, killsArtillery, killsFortification,
				killsHelicopters, killsInfantry, killsOther, killsPlanes,
				killsShips, killsUnarmed, /*masterslot, missionName,*/
				/*missionhashId, mstatus,*/ otherLandings, otherTakeoffs,
				//playerName, playerid, pvp, seat,
				shipLandings, shipTakeoffs, teamkills, /*time,*/
				//vehiculeId

			} = pilotData;

			const misc = [
				{
					title: "TeamKills",
					value: teamkills,
				},
				{
					title: "Ejections",
					value: ejections,
				},
				{
					title: "Crashes",
					value: crashes,
				},
				{
					title: "Deaths",
					value: deaths,
				}, /*
		 DATA NOT SHOWN AS SHOULD
		{
			title: "Total PvP kills",
			value: pvp,
		},
		{
			title: "Seat used",
			value: seat,
		},
		{
			title: "mstatus",
			value: mstatus,
		}	 */
			]

			const air = [
				{
					title: "Aircraft Units Destroyed",
					value: killsPlanes,
				},
				{
					title: "Helicopter Units Destroyed",
					value: killsHelicopters,
				}
			]

			const groundAndNaval = [
				{
					title: "Air Defense Units Destroyed",
					value: killsAirDefense,
				},
				{
					title: "Armored Units Destroyed",
					value: killsArmor,
				},
				{
					title: "Artillery Units Destroyed",
					value: killsArtillery,
				},
				{
					title: "Fortifications Destroyed",
					value: killsFortification,
				},
				{
					title: "Infantry Units killed",
					value: killsInfantry,
				},
				{
					title: "Unarmed Units Destroyed",
					value: killsUnarmed,
				},
				{
					title: "Naval Units Destroyed",
					value: killsShips,
				},
				{
					title: "Uncathegorized Units Destroyed",
					value: killsOther,
				}

			]

			const takeoffAndLandings = [
				{
					title: "Airfields Takeoffs",
					value: airfieldTakeoffs
				},
				{
					title: "Airfields Landings",
					value: airfieldLandings
				},
				{
					title: "FARP Takeoffs",
					value: farpTakeoffs
				},
				{
					title: "FARP Landings",
					value: farpLandings
				},
				{
					title: "Naval Takeoffs",
					value: shipTakeoffs
				},
				{
					title: "Naval Landings",
					value: shipLandings
				},
				{
					title: "Other Takeoffs",
					value: otherTakeoffs
				},
				{
					title: "Other Landings",
					value: otherLandings
				}
			]

			setState([air, groundAndNaval, takeoffAndLandings, misc])
		}

	}, [pilotData])

	return (
		<Switch>
			<Route path="/mission/:id/pilot/:id/air"	>
				{state && <PilotStatsContent data={state[0]} />}
			</Route>
			<Route path="/mission/:id/pilot/:id/ground&naval">
				{state && <PilotStatsContent data={state[1]} />}
			</Route>
			<Route path="/mission/:id/pilot/:id/takeoffs&landings">
				{state && <PilotStatsContent data={state[2]} />}
			</Route>
			<Route path="/mission/:id/pilot/:id/misc">
				{state && <PilotStatsContent data={state[3]} />}
			</Route>
		</Switch>
	)
}
export default PilotMissionStats ;
